import _ from '/home/ps/root'
export const q = {
  id: 0,
  modified: Math.round(Date.now()/1000),
  type: 'text',
  stock: 3,
  expire: _.LIFETIME
}
export default q
